// Import components to use
import "../components/loader/index";

// Import controllers to use
import SearchPanelController from "../controllers/SearchPanelController";
import CategoryTagsController from "../controllers/CategoryTagsController";
import ERIntegrationController from "../controllers/ERIntegrationController";
import IdeaNumberTextController from "../controllers/IdeaNumberTextController";

/**
 * Creates search component, add it to panels section after button to add a new post and initializes it.
 */
const search_load = async (): Promise<void> => {
  const $panel = document.createElement("ccc-panel");
  $panel.id = "SearchPanel";
  $panel.setAttribute("background-color", "white");
  const $searchPanel = document.createElement("ccc-search-panel");
  $searchPanel.slot = "component";
  $panel.appendChild($searchPanel);
  const $sideBar = document.querySelector(
    ".Panel.Panel-main .pageBox .ccc_panel"
  );
  $sideBar.insertBefore($panel, $sideBar.children[1]); // Possition 0 is for the button.
  // Initialize search panel component.
  const searchPanel: SearchPanelController = new SearchPanelController(
    "#SearchPanel"
  );
  searchPanel.init();
};

/**
 * Hides the parent tag if the discussion has tags.
 */
const hide_parent_tag = async (): Promise<void> => {
  const categoryTags: CategoryTagsController = new CategoryTagsController();
  categoryTags.hideParentTag();
};

/**
 * Adds options in discussion menu to create JIRA Epic or a registry in BugDB.
 */
const er_integration_load = async (): Promise<void> => {
  const erIntegration = new ERIntegrationController();
  erIntegration.init();
};

/**
 * Add idea number text to the idea metadata div
 */
const idea_number_text_load = async (): Promise<void> => {
  const iNumberCtrl = new IdeaNumberTextController();
  if (await iNumberCtrl.isIdeaLab()) {
    const loaded = await iNumberCtrl.addNumberMetadata();
    console.debug("Idea Number Text - Text added:", loaded);
  }
};
// Recipe
const discussion_recipe = async () => {
  console.info("Discussion recipe");

  search_load();
  hide_parent_tag();
  er_integration_load();
  idea_number_text_load();
};

discussion_recipe();
